<template>
  <!-- ==============================================
  **Footer opt1**
  ===================================================-->
  <footer class="footer d-print-none">
    <div class="container-custom bottom">
      <div class="row footer-sec d-flex">
            <div class="col-md-3 col-4 col-sm-4">
                <div class="quick-links">
                  <p class=" mb-2">VERTICALS</p>
                  <ul class="d-inline">
                    <!-- <li>
                      <router-link :to="{ name: 'dance-school' }" class="" target="_blank">Dance School</router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'corporate-training' }" class="" target="_blank">Corporate & Professional Training  </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'learning-academies' }" class="" target="_blank">Language & Learning Center</router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'fitness-sports' }" class="" target="_blank">Fitness & Sports Training Center</router-link>
                    </li> -->

                    <li>
                      <a :href="links.verticalDance" target="_blank">Dance School</a>
                    </li>
                    <li>
                      <a :href="links.verticalCorporate" target="_blank">Corporate & Professional Training</a>
                    </li>
                    <li>
                      <a :href="links.verticalLearning" target="_blank">Language & Learning Center</a>
                    </li>
                    <li>
                      <a :href="links.verticalFitness" target="_blank">Fitness & Sports Training Center</a>
                    </li>
                    
                  </ul>
                </div>
            </div>
            <div class="col-md-3 col-4 col-sm-4">
              <div class="quick-links">
                <p class="text-light mb-2">SITE MAP</p>
                <ul class="d-block">

                  <li>
                    <a :href="links.home" id="lnkFooterHome">Home</a>
                  </li>
                  <!-- <li>
                    <a :href="links.learn" id="lnkFooterLearn">Learn</a>
                  </li> -->
                  <li>
                    <a :href="links.aboutUs" id="lnkFooterAboutUs">About Us</a>
                  </li>
                  <li>
                    <a :href="links.privacy" id="lnkFooterPrivacy">Privacy Policy</a>
                  </li>
                  <li>
                    <a :href="links.refund" id="lnkFooterRefund">Refund Policy</a>
                  </li>
                  <li>
                    <a :href="links.terms" id="lnkFooterTerms">Term of Service</a>
                  </li>
                  <li>
                    <a :href="links.blog" id="lnkFooterBlog">Blog</a>
                  </li>
                  <li>
                      <router-link class="" :to="{ name: 'accessibility' }"
                        >Accessibility</router-link>
                    </li>
                </ul>
              </div>
            </div>

            <div class="col-md-3 col-4 col-sm-4">
              <div class="quick-links">
                <p class=" mb-2">SOCIAL MEDIA</p>
                <ul class="d-inline">
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/twitter.svg " alt=""></span> <a :href="social.x" target="_blank" id="lnkFooterRefund">Twitter</a>
                  </li>
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/linkedin.svg " alt=""></span> <a :href="social.linkedin" target="_blank" id="lnkFooterRefund">LinkedIn</a>
                  </li>
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/facebook.svg " alt=""></span> <a :href="social.facebook" target="_blank" id="lnkFooterRefund">Facebook</a>
                  </li>
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/youtube.svg " alt=""></span> <a :href="social.youtube" target="_blank" id="lnkFooterRefund">YouTube</a>
                  </li>
                  <li>
                    <span class="mr-1"> <img style="height: 16px;" src="/assets/images/icon/instagram.svg " alt=""></span> <a :href="social.instagram" target="_blank" id="lnkFooterRefund">Instagram</a>
                  </li>
                </ul>
              </div>
            </div>
            
        <div class="col-md-3 col-12 col-sm-12">
          <div class="quick-links">
            <p class=" mb-2">CONTACT US</p>
            <ul class="d-inline">
              <li class="">
                <!-- Contact emails are intentionally fixed to CircleRAM for all verticals (same company) -->
                <a href="mailto:learn@circleram.com">Sales: learn@circleram.com</a> <br>
                <a href="mailto:support@circleram.com">Support: support@circleram.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-6 mob-acco text-light footer-logo">
              <a href="/home"><img :src="brandLogoWhite" class="img-fluid mt-2 mb-2" alt=""
                style="height: 60px;" /></a>
              <div class="w-100 mt-2 mb-2">
                <span id="siteseal"></span>
              </div>
              <span> Copyright © {{ this.date }} {{ brandName }}. All Rights Reserved.</span>
        </div>
        <div class="col-sm-12 col-6 d-flex justify-content-end align-items-end">
          <div class="text-light">
            Powered by: <a :href="links.site" target="_blank" class="text-warning">{{ brandName }}</a>
          </div>
        </div>
      </div>

      <div class="row justify-content-end d-none">
        <div class="col-12 d-flex justify-content-end">
          <div class="text-light">
            Powered by: <a :href="links.site" target="_blank" class="text-warning">{{ brandName }}</a>
          </div>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>
import { onThisHost, siteBaseUrl } from '../../../../daoSource/services/siteUrl'
import brand from '../../../../daoSource/services/brand.service'

export default {
  name: 'Footer',
  data() {
    return {
      baseURL: siteBaseUrl(),
      brandName: brand.name,
      brandLogoWhite: brand.logoSrc('white'),
      links: {
        home: brand.link('home'),
        site: brand.link('site'),
        aboutUs: brand.link('aboutUs'),
        privacy: brand.link('privacy'),
        refund: brand.link('refund'),
        terms: brand.link('terms'),
        blog: brand.link('blog'),
        verticalDance: brand.link('verticalDance'),
        verticalCorporate: brand.link('verticalCorporate'),
        verticalLearning: brand.link('verticalLearning'),
        verticalFitness: brand.link('verticalFitness')
      },
      social: {
        x: brand.social('x'),
        linkedin: brand.social('linkedin'),
        facebook: brand.social('facebook'),
        youtube: brand.social('youtube'),
        instagram: brand.social('instagram')
      },
      date: new Date().getFullYear(),
      supportURL: onThisHost(process.env.VUE_APP_SUPPORT_BASE_URL)
    }
  },
  mounted() {
    let starfieldtechScript = document.createElement('script')
    starfieldtechScript.setAttribute('src', 'https://seal.starfieldtech.com/getSeal?sealID=HaarvVeYc7boSNbd0cOQIraekT151LSQtZasEiJadaLNpFs9x6SB3DjIm9kk')
    document.head.appendChild(starfieldtechScript)
  }
}
</script>
